import { Check as CheckIcon, Cross as CrossIcon, SolidPause } from '@factorialco/f0-react/icons/app'
import type { TimeInsightsEntitiesClockInStatusStatusEnum } from 'generated/resources/graphql'

export const getClockInStatusBadge = (
  status: TimeInsightsEntitiesClockInStatusStatusEnum | null | undefined
) => {
  if (!status) {
    return undefined
  }

  switch (status) {
    case 'missing_clock_in':
      return {
        icon: CrossIcon,
        type: 'critical' as const,
      }
    case 'in_a_break':
      return {
        icon: SolidPause,
        type: 'warning' as const,
      }
    case 'clocked_in':
      return {
        icon: CheckIcon,
        type: 'positive' as const,
      }
    default:
      return undefined
  }
}
